import { useL10n } from '@uplift/hooks';
import { SexEnum } from '@uplift/types';
import * as Yup from 'yup';
import { useSaveProfile } from '../../hooks';
import { useUpdateSettings } from '../../hooks/use-update-settings.hook';
import { useCurrentuser } from '@uplift/contexts';
import { useUserProfileQuery } from '@uplift/queries';

export type SexFormType = {
  sex: SexEnum;
};

export const useSexForm = () => {
  const l10n = useL10n();
  const { onFormSubmitSuccess, onFormSubmitError } = useUpdateSettings();
  const me = useCurrentuser();
  const { data: profile } = useUserProfileQuery(me.id, { suspense: true });
  const saveProfile = useSaveProfile();

  const sexFormik = () => {
    const initialValues: SexFormType = {
      sex: profile?.sex ?? SexEnum.female
    };

    const validationSchema = Yup.object({
      sex: Yup.string().required(l10n.validations.required)
    });

    const onSubmit = async (values: SexFormType) => {
      try {
        await saveProfile({
          sex: values.sex
        });

        onFormSubmitSuccess();
      } catch (error) {
        onFormSubmitError();
      }
    };

    return { initialValues, validationSchema, onSubmit };
  };

  return { sexFormik };
};
